import React, {PureComponent} from "react"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {Query} from "@irati/utils/apollo"
import {TrophyList} from "@irati/types"
import {gql} from "@irati/utils/gql"

const query = gql`
  query Trophies {
    trophies {
      results {
        alt
        href
        id
      }
    }
  }
`

export interface TrophiesData {
  data: {
    trophies: TrophyList
  }
}

interface Props {}

class TypedQuery extends Query<TrophiesData> {}

export default class TrophiesQuery extends PureComponent<Props> {
  render() {
    return <QueryComponent {...this.props} QueryComponent={TypedQuery} query={query} />
  }
}
